module.exports = __webpack_public_path__ + "static/img/teacher5.55d13a0f.png";